let styleTagId = 'custom-whitelabel-css';

export function applyCustomCSS(cssContent) {
  let styleTag = document.getElementById(styleTagId);

  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = styleTagId;
    document.head.appendChild(styleTag);
  }

  styleTag.innerHTML = cssContent || ''; 
}
